<template>
    <usage-chart-group
        v-if="chartData"
        :organizationId="organizationId"
        :chartConfig="chartConfig"
        :chartData="chartData"
        :themeProfileId="themeProfileId"
    />
</template>
<script>
    import { mapActions } from 'vuex';
    import UsageChartGroup from './UsageChartGroup.vue';
    export default {
        components: { 'usage-chart-group': UsageChartGroup },
        props: {
            organizationId: { type: Number, required: true },
            chartConfig: { type: Object, required: true },
            themeProfileId: { type: Number, required: false }
        },

        data: function () {
            return { chartData: null };
        },

        mounted: function () {
            this.init();
        },

        methods: {
            ...mapActions(['getUsageChartData']),
            async init() {
                this.chartData = await this.getChartData();
            },
            getChartData() {
                const organizationId = this.organizationId.toString();
                return this.getUsageChartData({
                    filter: '| where name == "customUserEvent" | where customDimensions.name == "themeActivated"',
                    organizationId
                });
            }
        }
    };
</script>
